<template>
  <div class="modal fade add-promo-modal" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
    id="add-promo-modal">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="container py-4 px-4">
          <b>
            <h4 style="text-align: center; color: #AC8400">Add Promotion</h4>
          </b>

          <InputLabel class="px-3" v-model="data.title" label="Title" placeholder="" type="text" :required="true" :errorMessage="errors.title"/>

          
          <div class="mt-3 px-3">
            <label class="form-label">Maximum Advanced Purchase Period</label>
            <div class="row">
              <div class="col-2">
                <label class="form-label">Up to</label>
              </div>
              <div class="col-3">
                <InputLabel v-model="data.value" type="number" :required="true" :errorMessage="errors.value"/>
              </div>
              <div class="col-3">
                <select class="form-control" :required="true" v-model="data.type">
                  <option v-for="(item, index) in duration_options" :key="index" :value="item.value" :selected="item.value == defaultType">{{ item.name }}</option>
                </select>
                <span class="invalid-feedback">{{ errors.type ? errors.type : '' }}</span>
              </div>

            </div>
          </div>

          <div class="row mt-3 px-3">
            <div class="col-6">
              <InputLabel v-model="data.start_date" label="Start Date" type="date" required :errorMessage="errors.start_date"/>
            </div>

            <div class="col-6">
              <InputLabel v-model="data.end_date" label="End Date" type="date" required :errorMessage="errors.end_date"/>
            </div>
          </div>

          <div class="row mt-3 px-3">
            <div class="col-6">
              <label class="form-label">Status</label>
              <span class="invalid-feedback">{{ radioErrorMsg }}</span>
            </div>
          </div>

          <div class="d-flex flex-row">
            <div v-for="(item, index) in advanced_options" :key="index">
              <label class="radio radio-gold ml-3">
                <input type="radio" name="advancedStatusPeriod" v-bind:value="item.value"
                  v-model="selectedRadio">
  
                <div class="d-flex flex-row child-flex-class">
                  <span>{{ item.name }}</span>
                </div>
                <span class="checkmark"></span>
              </label>
            </div>
          </div>

          <div style="text-align: center">
            <button class="btn mr-1"
              style="width: 100px; color: #AC8400; background-color: white; border-color: #AC8400;"
              @click="hideModal('#add-promo-modal')">
              Cancel
            </button>
            <button class="btn" style="width: 100px; color: white; background-color: #AC8400; border-color: #AC8400;"
              @click="handleSubmit">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { type } from 'jquery';
import InputLabel from '../../../components/UI/InputLabel.vue';


export default {
  name: "Modal",
  
  components: {
    InputLabel
  },

  props: {
    duration_options: {
      type: Array,
      required: true
    },
    autoSet: {
      type: Object,
      required: true
    },

    data: {
      type: Object,
      required: false,
      default: {
        title: '',
        start_date: '',
        end_date: '',
        type: '',
        value: '',
      },
    },

    errors: {
      type: Object,
      required: false,
      default: {
        title: '',
        start_date: '',
        end_date: '',
        type: '',
        value: '',
      },
    },

    radioErrorMsg: '',
  },

  data() {
    return {
      selectedRadio: '',
      advanced_options: [
        { value: 1, name: "Active" },
        { value: 0, name: "Inactive" },
      ],

      localData: {
        title: this.data.title || '',
        start_date: this.data.start_date || '',
        end_date: this.data.end_date || '',
        type: this.data.type || '',
        value: this.data.value || 0,
        status: this.data.status || 0,
      }

    };
  },

   watch: {
    selectedRadio: function (newVal, oldVal) {
      data.status = newVal;
    },
  },

  methods: {
    hideModal(name) {
      $(name).modal('hide');
    },

    async handleSubmit() {
      this.localData = { ...this.data, status: this.selectedRadio };

      if(this.selectedRadio == '') {
        this.radioErrorMsg = 'This field is required'
        return;
      }

      this.$emit("submitPromo", {...this.localData});
    },
  },
};
</script>


<style scoped>
.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
</style>
